import React, { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import useUpdatePassword from '../hooks/useUpdatePassword'
import Button from '@material-ui/core/Button'
import CssBaseline from '@material-ui/core/CssBaseline'
import TextField from '@material-ui/core/TextField'
import Link from '@material-ui/core/Link'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import { makeStyles } from '@material-ui/core/styles'
import Container from '@material-ui/core/Container'
import logoSpotter from '../images/logo_spotter-login.png'
import CircularProgress from '@material-ui/core/CircularProgress'
import DownloadAppPlaceHolder from './DownloadAppPlaceHolder'
function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Spotter
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  )
}

export default function ForgotPassword() {
  const classes = useStyles()
  const location = useLocation()
  const email = new URLSearchParams(location.search).get('email')
  const code = new URLSearchParams(location.search).get('code')
  const [password, setPassword] = useState('')
  const [submit, setSubmit] = useState(false)
  const updatePasswordRequest = useUpdatePassword(email, code, password, submit)
  useEffect(() => {
    if (
      !updatePasswordRequest.isLoading &&
      submit &&
      (updatePasswordRequest.data || updatePasswordRequest.error)
    ) {
      setSubmit(false)
    }
  }, [updatePasswordRequest.isLoading, updatePasswordRequest.error, submit])
  if (updatePasswordRequest.data) {
    return (
      <DownloadAppPlaceHolder title="Contraseña actualizada correctamente, continua desde nuestras apps" />
    )
  }
  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <div className={classes.paper}>
        <img src={logoSpotter} height="120px" alt="spotter"></img>
        <Typography component="h1" variant="h5">
          Cambiar contraseña
        </Typography>
        <div className={classes.form}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoFocus
            value={email}
            disabled
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="code"
            label="Codigo"
            name="code"
            autoFocus
            value={code}
            disabled
          />
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
            value={password}
            onChange={(evt) => {
              setPassword(evt.target.value)
            }}
            onKeyDown={(e) => e.key === 'Enter' && setSubmit(true)}
          />
          {updatePasswordRequest.isLoading ? (
            <CircularProgress className={classes.submit} />
          ) : (
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
              onClick={() => {
                setSubmit(true)
              }}
            >
              Cambiar contraseña
            </Button>
          )}
        </div>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  )
}

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}))
